import React, { createContext, useState, useEffect } from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";

interface UserContextProps {
  emulateUser: any;
  setEmulateUser: React.Dispatch<React.SetStateAction<any>>;
}

export const UserContext = createContext<UserContextProps>({
  emulateUser: null,
  setEmulateUser: () => {},
});

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [emulateUser, setEmulateUser] = useState<any>(null);

  useEffect(() => {
    const getEmulateUser = async () => {
      try {
        const emulateUserInfo = await AsyncStorage.getItem("emulatedUser");
        if (emulateUserInfo) {
          const parsedUser = JSON.parse(emulateUserInfo);
          console.log("Loaded emulateUser from storage:", parsedUser); 
          setEmulateUser(parsedUser);
        } else {
          console.log("No emulateUser found in storage."); 
        }
      } catch (error) {
        console.error("Error retrieving emulated user:", error);
      }
    };

    getEmulateUser();
  }, []);

  useEffect(() => {
    console.log("EmulateUser state updated:", emulateUser); 
  }, [emulateUser]);

  return (
    <UserContext.Provider value={{ emulateUser, setEmulateUser }}>
      {children}
    </UserContext.Provider>
  );
};
